import apiEventEndpoints from '@services/api/endpoints/apiEventEndpoints';
import { authApi } from '@services/api/endpoints/auth';
import { membersApi } from '@services/api/endpoints/members';
import { userApi } from '@services/api/endpoints/user';
import { conversationApi } from './conversations';
import { dedicatedForumsApi } from './dedicatedForums';
import { spaceObjectsApi } from './spaceobjects';
import { sstsApi } from './ssts';
import { unlistedSpaceObjectsApi } from './unlistedSpaceObjects';

type ApiEndpoints = {
  event: typeof apiEventEndpoints;
  spaceObjects: typeof spaceObjectsApi;
  auth: typeof authApi;
  user: typeof userApi;
  members: typeof membersApi;
  ssts: typeof sstsApi;
  conversation: typeof conversationApi;
  dedicatedForums: typeof dedicatedForumsApi;
  unlistedSpaceObjects: typeof unlistedSpaceObjectsApi;
};

const apiEndpoints: ApiEndpoints = {
  event: { ...apiEventEndpoints },
  spaceObjects: { ...spaceObjectsApi },
  auth: { ...authApi },
  user: { ...userApi },
  members: { ...membersApi },
  ssts: { ...sstsApi },
  conversation: { ...conversationApi },
  dedicatedForums: { ...dedicatedForumsApi },
  unlistedSpaceObjects: { ...unlistedSpaceObjectsApi },
};

export default apiEndpoints;
